module.exports = __webpack_public_path__ + "img/TXG_DISAssetKO.1f350c6f.svg";